import { render, staticRenderFns } from "./SalesByTerritory.vue?vue&type=template&id=3d610c6b&"
import script from "./SalesByTerritory.vue?vue&type=script&lang=js&"
export * from "./SalesByTerritory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports